import { Component } from '@angular/core';
import { NavController, ModalController } from 'ionic-angular';
import { DataServiceProvider } from "../../providers/data-service/data-service";
import { FeedingModalComponent } from "../../components/feeding-modal/feeding-modal";

@Component({
  selector: 'page-feeding',
  templateUrl: 'feeding.html'
})
export class FeedingPage {

  constructor(
    public navCtrl: NavController,
    public modalCtrl: ModalController,
    private dataService: DataServiceProvider,
  ) {
  }

  newFeeding(){
    let modal = this.modalCtrl.create(FeedingModalComponent,{});
    modal.present();
  }

  openFeeding(feeding:any){
    let modal = this.modalCtrl.create(FeedingModalComponent,{feeding:feeding});
    modal.present();
  }

  removeFeeding(feeding:any){
    this.dataService.removeFeeding(feeding);
  }

}



// WEBPACK FOOTER //
// ./src/pages/feeding/feeding.ts